// Game state management types for Beats of the Ancients

export type GameScreen = 'intro' | 'level-select' | 'puzzle' | 'victory';

export interface GameSettings {
  volume: number; // 0-1 for volume control
}

export interface GameState {
  currentScreen: GameScreen;
  currentLevel: string | null;
  completedLevels: Set<string>;
  settings: GameSettings;
}

export interface LevelProgress {
  completedLevels: string[];
  settings: GameSettings;
}

// Helper functions for localStorage persistence
export const loadGameProgress = (): LevelProgress => {
  try {
    const saved = localStorage.getItem('beats-of-ancients-progress');
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        completedLevels: parsed.completedLevels || [],
        settings: {
          volume: parsed.settings?.volume ?? 0.7, // Default 70%
        }
      };
    }
  } catch (error) {
    console.warn('Failed to load game progress:', error);
  }
  
  return {
    completedLevels: [],
    settings: { volume: 0.7 }
  };
};

export const saveGameProgress = (progress: LevelProgress): void => {
  try {
    localStorage.setItem('beats-of-ancients-progress', JSON.stringify(progress));
  } catch (error) {
    console.warn('Failed to save game progress:', error);
  }
};

export const clearGameProgress = (): void => {
  try {
    localStorage.removeItem('beats-of-ancients-progress');
    console.log('Game progress cleared');
  } catch (error) {
    console.warn('Failed to clear game progress:', error);
  }
};

export const getStoredProgress = (): any => {
  try {
    const stored = localStorage.getItem('beats-of-ancients-progress');
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.warn('Failed to get stored progress:', error);
    return null;
  }
};